import { BrandliveEvent } from '@/types/projects.types';
import { Get } from '../helpers';

export const GetProject = (eventUuid: string): Promise<BrandliveEvent | { error: number }> => {
  return Get({
    path: `/v3/admin/event/${eventUuid}?includeGlobalTemplatesChannel=true&includeOriginatingTemplate=true`,
  });
};
